import {
  getJwt,
  getBrandFromHostname,
  getEnvironmentLabel,
  getCustomerCode,
  getUserCredential,
  isLocalhost
} from "@maersk-global/shared-js";
import { handleErrors } from "@/lib/utilities";
import CONSTANTS from "@/lib/CONSTANTS";

const brandCode = getBrandFromHostname(window.location).brandCode;
const customerCode = getCustomerCode();
const userId = isLocalhost() ? "localUser" : getUserCredential("personid");
const env = getEnvironmentLabel();

export const getShipments = (queryParams, additionalResources) =>
  fetch(
    `${CONSTANTS.apiPaths.billsOfLadingSummaryApi}?` +
      new URLSearchParams({
        carrierCustomerCode: customerCode,
        vesselOperatorCarrierCode: brandCode.toUpperCase(),
        ...queryParams
      }),
    {
      headers: {
        "additional-resources": additionalResources,
        Authorization: `Bearer ${getJwt()}`,
        "Consumer-Key": CONSTANTS.CONSUMER_KEYS.bolSummary
      }
    }
  )
    .then((res) => handleErrors(res))
    .then(async (r) => {
      const headers = {};
      r.headers.forEach((value, key) => (headers[key] = value));
      return { data: await r.json(), headers };
    });

export const ApiLocationsGet = (queryParams) =>
  fetch(`${CONSTANTS.apiPaths.locationsApi}?` + new URLSearchParams(queryParams), {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
      "Content-Type": "application/json",
      "Consumer-Key": CONSTANTS.CONSUMER_KEYS.HSM[env],
      Accept: "application/json"
    }
  });

export const ApiFavouritesPost = async (favouriteValue, update) => {
  const body = {
    userId,
    customerCode,
    applicationName: "shipment-management-ui",
    componentName: "savedFilters",
    brandCode: brandCode.toUpperCase(),
    favouritesData: favouriteValue
  };

  const res = await fetch(`${CONSTANTS.apiPaths.favouritesApi}`, {
    method: update ? "PUT" : "POST",
    headers: {
      Authorization: `Bearer ${getJwt()}`,
      "Consumer-Key": CONSTANTS.CONSUMER_KEYS.HSM[env],
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });
  return handleErrors(res);
};

export const ApiFavouritesDelete = () =>
  fetch(
    `${CONSTANTS.apiPaths.favouritesApi}?` +
      new URLSearchParams({
        userId,
        customerCode,
        applicationName: "shipment-management-ui",
        componentName: "savedFilters",
        brandCode: brandCode.toUpperCase()
      }),
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${getJwt()}`,
        "Consumer-Key": CONSTANTS.CONSUMER_KEYS.HSM[env],
        "Content-Type": "application/json"
      }
    }
  ).then((res) => handleErrors(res));

export const ApiFavouritesGet = (queryParams) =>
  fetch(
    `${CONSTANTS.apiPaths.favouritesApi}?` +
      new URLSearchParams({
        userId,
        customerCode,
        applicationName: "shipment-management-ui",
        componentName: "savedFilters",
        brandCode: brandCode.toUpperCase(),
        ...queryParams
      }),
    {
      headers: {
        Authorization: `Bearer ${getJwt()}`,
        "Consumer-Key": CONSTANTS.CONSUMER_KEYS.HSM[env]
      }
    }
  ).then((res) => handleErrors(res));

export const ApiVesselsGet = () =>
  fetch(`${CONSTANTS.apiPaths.vesselsApi}?carrierCodes=MAEU,MCPU,SEAU,SEJJ`, {
    headers: {
      Accept: "application/json",
      "Consumer-Key": CONSTANTS.CONSUMER_KEYS.vessels[env]
    }
  }).then((res) => handleErrors(res));

export const ApiWebBillOfLadingsPermissions = () =>
  fetch(
    `${CONSTANTS.apiPaths.customersApi}/web-bill-of-ladings-permissions/${getCustomerCode()}?brandCode=${brandCode.toUpperCase()}`,
    {
      headers: {
        Authorization: `Bearer ${getJwt()}`,
        "Consumer-Key": CONSTANTS.CONSUMER_KEYS.HSM[env]
      }
    }
  )
    .then((res) => handleErrors(res))
    .then((r) => r.json());

export const postDocumentsDownload = (documents) =>
  fetch(`${CONSTANTS.apiPaths.shipmentDetailsApi}/documents/download`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getJwt()}`,
      "Consumer-Key": CONSTANTS.CONSUMER_KEYS.shipmentDetailsRouter,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      documents
    })
  })
    .then((res) => handleErrors(res))
    .then((r) => r.json());

export const ApiPublicDataGet = () =>
  fetch(`${CONSTANTS.apiPaths.cmdSearchPublicDataApi}?customerCode=${customerCode}`, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
      "Consumer-Key": CONSTANTS.CONSUMER_KEYS.HSM[env]
    }
  })
    .then((res) => handleErrors(res))
    .then((r) => r.json());

export const ApiOrderBlPaper = (body) => {
  return fetch(`${CONSTANTS.apiPaths.orderBlPaperApi}`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      Authorization: `Bearer ${getJwt()}`,
      "Consumer-Key": CONSTANTS.CONSUMER_KEYS.orderBlPaper,
      "Content-Type": "application/json"
    }
  })
    .then((res) => handleErrors(res))
    .then((r) => r.json());
};

export const getAirLcl = (type, queryParams) => {
  return fetch(
    `${CONSTANTS.apiPaths.airLclApi}/${getCustomerCode()}?` +
      new URLSearchParams({
        transportMode: type,
        ...queryParams
      }),
    {
      headers: {
        Authorization: `Bearer ${getJwt()}`,
        "Consumer-Key": CONSTANTS.CONSUMER_KEYS.HSM[env]
      }
    }
  )
    .then((res) => handleErrors(res))
    .then(async (r) => {
      const headers = {};
      r.headers.forEach((value, key) => (headers[key] = value));
      return { data: await r.json(), headers };
    });
};

export const getAirLclCount = (type) =>
  fetch(`${CONSTANTS.apiPaths.airLclApi}/${getCustomerCode()}?isCountByTransportMode=true&transportMode=${type}`, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
      "Consumer-Key": CONSTANTS.CONSUMER_KEYS.HSM[env]
    }
  })
    .then((res) => handleErrors(res))
    .then((r) => r.json());

export const getCustomerPublicData = () => {
  return fetch(`${CONSTANTS.apiPaths.customersApi}/public-data?customerCode=${getCustomerCode()}`, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
      "Consumer-Key": CONSTANTS.CONSUMER_KEYS.HSM[env]
    }
  })
    .then((res) => handleErrors(res))
    .then((r) => r.json());
};
